<template>
	<div class="login-page__content">
		<div class="nav-background md:nav-background--right">
			<div class="nav-background__img">
				<img :src="getAssetPath('backgrounds/login-page-bg.jpg')"/>
			</div>
		</div>

		<div class="gr pt-12">
			<div class="text-white text-center mt-2 sm:mt-10 sm:pt-1 mb-3 sm:mb-8">
				<h2 class="text-3xl sm:text-4xl sm:mb-2">Reset your password</h2>
				<h3 class="text-lg sm:text-2xl">Enter your account email, and we&rsquo;ll send you a password reset.</h3>
			</div>

			<div class="login-box sm:bg-ma-gray-0">
				<ResetPasswordForm />
			</div>
		</div>
	</div>
</template>

<script>
	import ResetPasswordForm from './components/ResetPasswordForm';
  import {getAssetPath} from "@/utils/contentDelivery";

	export default {
		components: {
			ResetPasswordForm
		},
		metaInfo: () => ({
            bodyAttrs: { class: 'with--nav-background login-page'},
            title: 'Reset your Password | Motion Array',
            link: [ {  rel:'stylesheet', href: '/assets/site/css/login.css?v=2' } ]
        }),
    methods: {
      getAssetPath,
    }
	}
</script>